"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionTypes = void 0;
var actionTypes = {
  SUCCESS: "@@impact/success",
  ERROR: "@@impact/error",
  LIST_BY_ID_YEAR: "@@impact/list-by-id-year",
  LIST: "@@impact/list",
  LISTSORT: "@@impact/list-sort",
  CRITERIA_LIST: "@@impact/criteria-list",
  CREATE: "@@impact/create",
  UPDATE: "@@impact/update",
  DELETE: "@@impact/delete",
  TYPE_LIST: "@@impact/type-list",
  DELETE_ALL: "@@impact/delete-all",
  SEQUENCE: "@@impact/sequence",
  RESET: "@@impact/reset",
  RESET_ACTION: "@@impact/reset-action",
  RESET_LISTBYIDYEAR: "@@impact/listByIdYear-reset",
  SOFT_DELETE: "@@impact/soft_delete",
  RESTORE_SOFT_DELETE: "@@impact/restore_soft_delete",
  LIST_RESTORE_SOFT_DELETE: "@@impact/list_restore_soft_delete",
  BULK_RESTORE: "@@impact/bulk-restore",
  BULK_DELETE: "@@impact/bulk-delete",
  BULK_SOFT_DELETE: "@@impact/bulk-soft-delete"
};
exports.actionTypes = actionTypes;